module.exports = __webpack_public_path__ + "static/media/empty-banner-bg.dfbe128f.png";